import { Autocomplete, TextField } from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";
import { useEffect, useState } from "react";

export function ActividadEconomicaAutocomplete({
  label = "Actividad económica",
  value = 0,
  onChange = () => {},
  required = true,
  disabled = false,
}) {
  const { actividadesEconomicas } = useResourcesContext();

  const [options] = useState(() =>
    actividadesEconomicas.map((actividad_economica) => ({
      label: `${actividad_economica.actividad_economica_id} - ${actividad_economica.actividad_economica_descripcion}`,
      ...actividad_economica,
    }))
  );

  const [currentValue, setCurrentValue] = useState(null);

  useEffect(() => {
    const option = options.find(
      (option) => option.actividad_economica_id === value
    );

    setCurrentValue(option || null);
  }, [options, value]);

  return (
    <Autocomplete
      value={currentValue}
      options={options}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} />
      )}
      onChange={(e, value) => {
        setCurrentValue(value);

        return onChange(value?.actividad_economica_id || 0);
      }}
      disabled={disabled}
    />
  );
}
